import { getEnumValues, DropdownOption, depascalize } from "sprint-common-web";

export enum DeliveryEndpointType {
    Smartjog = 1,
    Aspera = 2,
    Signiant = 3
}

export const deliveryEndpointTypeDropdownOptions = getEnumValues(DeliveryEndpointType).map(
    (type: DeliveryEndpointType): DropdownOption => ({
        key: type.toString(),
        text: depascalize(DeliveryEndpointType[type])
    })
);
